import React from 'react';
import { Target, Eye } from 'lucide-react';
import { missionVision } from '../data/mock';

export const MissionVision = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0A1F3D] to-[#0D2847] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-1/2 left-0 w-72 h-72 bg-[#C9A14A]/10 rounded-full blur-3xl" />
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-[#C9A14A]/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Mission */}
          <div className="group relative bg-white/5 backdrop-blur-lg rounded-3xl p-10 hover:bg-white/10 transition-all duration-500 hover:transform hover:scale-105">
            <div className="flex items-start mb-6">
              <div className="w-16 h-16 bg-[#C9A14A]/20 rounded-2xl flex items-center justify-center group-hover:bg-[#C9A14A] transition-all duration-300">
                <Target className="w-8 h-8 text-[#C9A14A] group-hover:text-[#0A1F3D]" />
              </div>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4 group-hover:text-[#C9A14A] transition-colors duration-300">
              Our Mission
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed">
              {missionVision.mission}
            </p>
            {/* Border Glow */}
            <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-[#C9A14A]/50 transition-all duration-300 pointer-events-none" />
          </div>

          {/* Vision */}
          <div className="group relative bg-white/5 backdrop-blur-lg rounded-3xl p-10 hover:bg-white/10 transition-all duration-500 hover:transform hover:scale-105">
            <div className="flex items-start mb-6">
              <div className="w-16 h-16 bg-[#C9A14A]/20 rounded-2xl flex items-center justify-center group-hover:bg-[#C9A14A] transition-all duration-300">
                <Eye className="w-8 h-8 text-[#C9A14A] group-hover:text-[#0A1F3D]" />
              </div>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4 group-hover:text-[#C9A14A] transition-colors duration-300">
              Our Vision
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed">
              {missionVision.vision}
            </p>
            {/* Border Glow */}
            <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-[#C9A14A]/50 transition-all duration-300 pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
};
